<template>
  <div>
    <div class="owner_title">文件上传记录</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主编辑" prop="operator_name">
          <el-input v-model="filter_form.operator_name"></el-input>
        </el-form-item>
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="seas_box">
      <!-- 表格数据    -->
      <el-table
        height="550"
        ref="multipleTable"
        :data="dataShow"
        border
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="operator_name"
          label="金主编辑"
          width="200"
          align="center"
          sortable
        >
        </el-table-column>

        <el-table-column
          property="writer_nickname"
          label="写手昵称"
          width="200"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          width="200"
          sortable
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <div class="file_box">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                multiple
                :on-success="uploadFile"
                :show-file-list="false"
              >
                <div class="remark_btn" @click="upload(scope.row)">
                  <i class="iconfont icon-shangchuan"></i>
                  上传文件
                </div>
              </el-upload>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  connectionessay_file_list,
  connectionessay_file_up
} from "@/utils/writer";
export default {
  data() {
    return {
      writerId: "", //所属写手部id
      uploadUrl: this.$global.fileUploadUrl,
      uploadFileList: [], //文件上传列表
      uploadFileId: "", //文件上传id
      isFilterForm: true, //筛选表单
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        operator_name: "", //金主编辑
        connectionessay_name: "", //书名
        createtime: "" //创建时间范围
      },
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getUploadFileList();
  },
  methods: {
    // 获取接单中心列表
    getUploadFileList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId
      };
      connectionessay_file_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.uploadFileList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 筛选
    goSearch() {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (date1 == undefined && date2 == undefined) {
        that.time_filter = "";
      } else {
        that.time_filter = date1 + " - " + date2;
      }
      console.log("that.time_filter", that.time_filter);
      that.filter_form.createtime = that.time_filter;
      let obj = {
        departmentuser_id: that.writerId,
        ...that.filter_form
      };

      connectionessay_file_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.uploadFileList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 文件上传id
    upload(val) {
      var that = this;
      that.uploadFileId = val.id;
    },
    //文件上传
    uploadFile(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: that.uploadFileId,
        file: val.data.url
      };
      connectionessay_file_up(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.goSearch();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 计算页数的方法
    calcPageData() {
      if (this.uploadFileList.length > 1) {
        this.pageNum =
          Math.ceil(this.uploadFileList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.uploadFileList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.seas_box {
  margin: 0px 15px;
}
.task_btn {
  /* width: 90px;
  height: 25px;
  text-align: center;
  line-height: 5px; */
  background: #f3f8ff;
  color: #157df8;
}
.mywriter_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #157df8;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.mywriter_btn i {
  font-size: 12px;
}
.info_icon {
  font-size: 12px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding-top: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.sea_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.remark_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
  margin-left: 5px;
}
.remark_btn i {
  font-size: 12px;
}

.seas_box .el-tag {
  width: 90px;
  margin: 5px auto;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.file_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .seas_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/UploadFileRecord.vue